import { Navigate, useLocation } from "react-router-dom";
import { dashboardPath, useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#050506]"
        data-testid="protected-route-loading"
      >
        <div className="flex flex-col items-center gap-4">
          <div className="h-10 w-10 rounded-full border-2 border-[#222530] border-t-[#D4AF37] animate-spin" />
          <p className="text-sm text-[#64748B] font-mono tracking-widest">AUTHENTICATING</p>
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search + location.hash }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={dashboardPath(user.role)} replace />;
  }

  return children;
}
